import { gql } from '@apollo/client';
import { CHAT_MESSAGE_FIELDS } from '../queries/chat';

export const SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage($body: String!, $pagePath: String) {
    sendChatMessage(body: $body, pagePath: $pagePath) {${CHAT_MESSAGE_FIELDS}    }
  }
`;

export const MARK_CHAT_READ = gql`
  mutation MarkChatRead {
    markChatRead
  }
`;

/** Ask Tippa for a multi or a quaddie: returns the member's tap and Tippa's answer. */
export const ASK_TIPPA = gql`
  mutation AskTippa($request: AskTippaInput!, $pagePath: String) {
    askTippa(request: $request, pagePath: $pagePath) {${CHAT_MESSAGE_FIELDS}    }
  }
`;
